import { MissingBankAccount } from 'api/types/missingInformationReportTypes';
import { BankAccountDetailsDrawerVariant } from './types';

export const getTableToolbarText = (
  totalNumberOfItems: number,
  currentPage: number,
  itemsPerPage: number,
) => {
  if (totalNumberOfItems === 0) {
    return '';
  }

  const startItem = currentPage * itemsPerPage + 1;
  const endItem = Math.min((currentPage + 1) * itemsPerPage, totalNumberOfItems);

  return `Showing ${startItem}-${endItem} of ${totalNumberOfItems} Employees`;
};

export const getGenderText = (gender: 'm' | 'f' | 'o' | null) => {
  if (gender === 'm') {
    return 'Male';
  }
  if (gender === 'f') {
    return 'Female';
  }
  if (gender === 'o') {
    return 'Other';
  }
  return gender;
};

export const getDrawerMessage = (
  variant: BankAccountDetailsDrawerVariant,
  verificationStatus: MissingBankAccount['verification_status'],
) => {
  if (variant === 'incorrect') {
    return "This employee's bank account details were found to be invalid during penny-drop verification. Please ask them to update their bank details.";
  }

  if (verificationStatus === 'failed') {
    return 'The penny-drop verification for this bank account has failed. You can retry verification once the employee confirms their details are correct.';
  }

  return 'This bank account is yet to be verified via penny-drop. Verification is pending or in progress.';
};
